import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#496E2D\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#D80027\" d=\"M16.696 11.999H12v12c1.403 0 2.749-.241 4-.684z\"></path><path fill=\"#FF9811\" d=\"M20 20.943a11.97 11.97 0 0 0 4-8.944h-4.695z\"></path><path fill=\"#000\" d=\"M16 11.999v11.316a12 12 0 0 0 4-2.373V12z\"></path><path fill=\"#FF9811\" d=\"M22.172 7.827h-3.13a1.043 1.043 0 0 0-2.087 0h-3.13c0 .576.501 1.043 1.077 1.043h-.034c0 .577.467 1.044 1.043 1.044 0 .576.467 1.043 1.044 1.043h2.087c.576 0 1.043-.467 1.043-1.043.576 0 1.044-.467 1.044-1.044h-.035c.576 0 1.078-.467 1.078-1.043\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }